export default __webpack_public_path__ + "static/media/fb.0caf404e.svg";